import React from "react";
import './Companies.css'
const Companies = () => {
  return (
    <section className="c-wrapper">
      <div className="paddings innerWidth flexCenter c-container">
        <img src="./mastercardd.jpeg" alt="" />
        <img src="./paypall.jpeg" alt="" />
        <img src="./ncba.jpeg" alt="" />
        <img src="./Visaa.jpeg" alt="" />
        <img src="./mpesa.jpeg" alt="" />
      </div>
    </section>
  );
};

export default Companies;
